import logger from 'src/utils/logger/logger';
export default function detection (agent) {
  let comp_agent = agent.indexOf("maple") != -1;
  if (comp_agent) {
    logger.info ("[samsung orsay detection] detected");
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/samsung/detection.js